const isContrastMode = localStorage.getItem('contrast_mode')

if (isContrastMode) {
  document.documentElement.classList.add('body--contrast')
} else {
  document.documentElement.classList.remove('body--contrast')
}
